import React from 'react';
import WorkflowTaskNode from './WorkflowTaskNode';

/**
 * Shared Task Cell Component
 * Groups multiple same-day, same-type tasks into a single bordered container
 * with horizontal dividers between tasks.
 * 
 * Per mockup:
 * - Each task has 20px padding
 * - 2px horizontal divider between tasks: #568ded 50%, rounded, 20px horizontal padding
 * - Container has the #568ded 10% background
 */
const SharedTaskCell = ({
    tasks = [],
    onMenuAction,
    onToggleComplete,
    canManageTask = true,
    canToggleTaskCompletion = () => true
}) => {
    if (!tasks || tasks.length === 0) {
        return null;
    }

    // If only one task, just render a normal task node
    if (tasks.length === 1) {
        const task = tasks[0];
        return (
            <WorkflowTaskNode
                task={task}
                isCompleted={task.status === 'completed'}
                onMenuAction={onMenuAction}
                onToggleComplete={onToggleComplete}
                canManageTask={canManageTask}
                canToggleTaskCompletion={canToggleTaskCompletion}
            />
        );
    }

    // Check if all tasks are completed
    const allCompleted = tasks.every(t => t.status === 'completed');

    // Multiple tasks - render in shared cell
    return (
        <div className={`shared-task-cell ${allCompleted ? 'completed' : ''}`}>
            {tasks.map((task, index) => (
                <React.Fragment key={task.id || index}>
                    <WorkflowTaskNode
                        task={task}
                        isCompleted={task.status === 'completed'}
                        onMenuAction={onMenuAction}
                        onToggleComplete={onToggleComplete}
                        isInsideSharedCell={true}
                        canManageTask={canManageTask}
                        canToggleTaskCompletion={canToggleTaskCompletion}
                    />
                    {/* Horizontal divider between tasks (not after last task) */}
                    {index < tasks.length - 1 && (
                        <div className="shared-cell-divider" />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default SharedTaskCell;
